/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Leaveorganization2Inputs */

const zh_organizationsettings_leaveorganization2 = /** @type {(inputs: Organizationsettings_Leaveorganization2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`离开组织`)
};

const en_organizationsettings_leaveorganization2 = /** @type {(inputs: Organizationsettings_Leaveorganization2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave Organization`)
};

const es_organizationsettings_leaveorganization2 = /** @type {(inputs: Organizationsettings_Leaveorganization2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abandonar organización`)
};

/**
* | output |
* | --- |
* | "Leave Organization" |
*
* @param {Organizationsettings_Leaveorganization2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_leaveorganization2 = /** @type {((inputs?: Organizationsettings_Leaveorganization2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Leaveorganization2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_leaveorganization2(inputs)
	if (locale === "en") return en_organizationsettings_leaveorganization2(inputs)
	return es_organizationsettings_leaveorganization2(inputs)
});
export { organizationsettings_leaveorganization2 as "organizationSettings_leaveOrganization" }